import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { GrBox, palette, typography } from "@jnpmedi/grebob";
import { NavLink } from "react-router-dom";

export type NavItemProp = {
  $isActive: boolean;
};

const navItemStyles = {
  base: css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 10px",
    gap: "8px",
    width: "100%",
    borderRadius: "6px",
    boxSizing: "border-box",
    cursor: "pointer",
    textDecoration: "none",
    color: palette["grey070"],
    backgroundColor: "transparent",
    ".menu-item-text": {
      ...typography["Content.Body03"],
    },

    "&:hover": {
      backgroundColor: palette["grey020"],
      color: palette["grey070"],
    },

    "&:active": {
      backgroundColor: palette["grey025"],
    },
  }),

  active: css({
    color: `${palette["white"]} !important`,
    backgroundColor: `${palette["maven-blue-bright"]} !important`,
    ".menu-item-text": {
      ...typography["Content.Subtitle03"],
    },
  }),
};

const NavWrapper = styled(GrBox)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "4px",
  boxSizing: "border-box",
  minWidth: "36px",
});

const NavItem = styled(NavLink, {
  shouldForwardProp: (propName) => !["$isActive"].includes(propName),
})<NavItemProp>`
  ${navItemStyles.base};

  ${({ $isActive }) => $isActive && navItemStyles.active};
`;

const ExternalNavItem = styled("a")(() => ({
  ...navItemStyles.base,
}));

const NavItemText = styled(GrBox)`
  user-select: none;
  white-space: nowrap;
`;

const Style = {
  NavWrapper,
  NavItem,
  ExternalNavItem,
  NavItemText,
};

export default Style;
